<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <div id="user-data">
      <!-- {{"Permissao adicionar "+canAddEmp}} -->
      <vx-card title="Dados do Utilizador" class="mb-base">
        <div class="vx-col w-1/2  mb-5">
          <v-select v-on:change="verifyPermissions" placeholder="selecione o utilizador" :options="users" label="name"
            v-model="selectedUser"></v-select>
        </div>
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img v-if="selectedUser.image" :src="selectedUser.image" class="rounded w-full" />
              <i v-else class="fad fa-user-circle fa-5x ml-5 text-primary"></i>
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Nome</td>
                <td>{{ selectedUser.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Apelido</td>
                <td>{{ selectedUser.surname }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ selectedUser.email }}</td>
              </tr>
            </table>
            <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
          </div>



        </div>

      </vx-card>

      <vx-card>
        <vs-tabs>
          <vs-tab label="Permissões" icon-pack="feather" icon="icon-lock">

            <vs-divider />

            <div class="block overflow-x-auto">
              <table class="w-full permissions-table">
                <tr>
                  <!--
                  You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                  our data structure. You just have to loop over above variable to get table headers.
                  Below we made it simple. So, everyone can understand.
                 -->
                  <th class="font-semibold text-base text-left px-3 py-2"
                    v-for="heading in ['Módulo', 'Leitura', 'Criação', 'Actualização', 'Eliminar', 'Aprovação']"
                    :key="heading">{{ heading }}</th>
                </tr>


                <tr>
                  <td class="px-3 py-2">Funcionarios</td>
                  <td class="px-3 py-2">
                    <!-- <vs-checkbox vs-value="list Employee" v-model="permission_name" class="pointer-events" /> -->
                    <vs-checkbox vs-value="list Employee" v-model="canListEmp" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Employee" v-model="canAddEmp" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Employee" v-model="canUpdateEmp" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Employee" v-model="canDeleteEmp" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Employee" v-model="canApproveEmp" class="pointer-events" />
                  </td>
                </tr>

                <tr>
                  <td class="px-3 py-2">Assiduidade</td>
                  <td class="px-1 py-2">
                    <vs-checkbox vs-value="list Attendance" v-model="canListAttendance" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Attendance" v-model="canAddAttendance" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Attendance" v-model="canUpdateAttendance" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Attendance" v-model="canDeleteAttendance" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Attendance" v-model="canApproveAttendance" class="pointer-events" />
                  </td>
                </tr>

                <!-- <tr >
                <td class="px-3 py-2">Licenças</td>
              <td class="px-1 py-2">
                <vs-checkbox vs-value="list Employee" v-model="ok" class="pointer-events" />
              </td>
              <td class="px-3 py-2">
                 <vs-checkbox vs-value="create Employee" v-model="ok" class="pointer-events" />
              </td>
               <td class="px-3 py-2">
                  <vs-checkbox vs-value="update Employee" v-model="ok" class="pointer-events" />
                </td>
                 <td class="px-3 py-2">
                  <vs-checkbox vs-value="delete Employee" v-model="ok" class="pointer-events" />
                </td>
                <td class="px-3 py-2">
                  <vs-checkbox vs-value="approve Employee" v-model="ok" class="pointer-events" />
                </td>
              </tr> -->


                <tr>
                  <td class="px-3 py-2">Processamento <br> de salários</td>
                  <td class="px-1 py-2">
                    <vs-checkbox vs-value="list Payroll" v-model="canListPayroll" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Payroll" v-model="canAddPayroll" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Payroll" v-model="canUpdatePayroll" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Payroll" v-model="canDeletePayroll" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Payroll" v-model="canApprovePayroll" class="pointer-events" />
                  </td>
                </tr>
                <tr>
                  <td class="px-3 py-2">Gestão de férias</td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="list Vacation" v-model="canListVacation" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Vacation" v-model="canAddVacation" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Vacation" v-model="canUpdateVacation" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Vacation" v-model="canDeleteVacation" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Vacation" v-model="canApproveVacation" class="pointer-events" />
                  </td>
                </tr>

                <tr>
                  <td class="px-3 py-2">Gestão de turnos</td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="list Shift" v-model="canListShift" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Shift" v-model="canAddShift" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Shift" v-model="canUpdateShift" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Shift" v-model="canDeleteShift" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Shift" v-model="canApproveShift" class="pointer-events" />
                  </td>
                </tr>


                <tr>
                  <td class="px-3 py-2">Gestão de horas extras</td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="list Extra_Hour" v-model="canListExtra_Hour" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="create Extra_Hour" v-model="canAddExtra_Hour" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="update Extra_Hour" v-model="canUpdateExtra_Hour" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="delete Extra_Hour" v-model="canDeleteExtra_Hour" class="pointer-events" />
                  </td>
                  <td class="px-3 py-2">
                    <vs-checkbox vs-value="approve Extra_Hour" v-model="canApproveExtra_Hour" class="pointer-events" />
                  </td>
                </tr>
              </table>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button class="ml-auto  mt-2" type="border" color="warning"
                    @click="removerPermissao">Remover</vs-button>
                  <vs-button class="ml-4 mt-2" @click="saveData">Salvar</vs-button>
                </div>
              </div>
            </div>
          </vs-tab>

          <vs-tab label="Funções" icon-pack="feather" icon="icon-box">
            <vs-divider />


            <div class="vx-row mt-5">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="admin" v-model="roleAdmin"><strong> Administrador </strong></vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Funcionario" v-model="roleFuncionario">Funcionário</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Funcionario" v-model="roleGestorFuncionario">Gestor de
                  Funcionário</vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Assiduidade" v-model="roleAssiduidade">Gestor de
                  Assiduidade</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Licenças" v-model="roleLicencas">Gestor de Licenças</vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Remunerações" v-model="roleRemuneracoes">Gestor de
                  Remunerações</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Utilizadores" v-model="roleUtilizadores">Gestor de
                  Utilizadores</vs-checkbox>
              </div>

              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Horas" v-model="roleHoras">Gestor de Horas extras</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Ferias" v-model="roleFerias">Gestor de férias</vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-checkbox vs-value="Gestor de Turnos" v-model="roleTurnos">Gestor de turnos</vs-checkbox>
              </div>
            </div>


            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="mr-3 mb-2" @click="saveRoles">Salvar</vs-button>
                <vs-button color="warning" type="border" class="mb-2">Remover</vs-button>
              </div>
            </div>
          </vs-tab>


        </vs-tabs>



      </vx-card>

    </div>
  </div>
</template>

<script>
import http from '../../../../http-common';
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
    return {
      users: [],
      selectedUser: [],
      permission_name: [],
      role_name: [],
      err: "",

      //////////////permissoes funcionario//////////////
      canListEmp: false,
      canAddEmp: false,
      canUpdateEmp: false,
      canDeleteEmp: false,
      canApproveEmp: false,


      canListAttendance: false,
      canAddAttendance: false,
      canUpdateAttendance: false,
      canDeleteAttendance: false,
      canApproveAttendance: false,

      canListPayroll: false,
      canAddPayroll: false,
      canUpdatePayroll: false,
      canDeletePayroll: false,
      canApprovePayroll: false,


      canLisVacation: false,
      canAddVacation: false,
      canUpdateVacation: false,
      canDeleteVacation: false,
      canApproveVacation: false,

      canListShift: false,
      canAddShift: false,
      canUpdateShift: false,
      canDeleteShift: false,
      canApproveShift: false,

      canListExtra_Hour: false,
      canAddExtra_Hour: false,
      canUpdateExtra_Hour: false,
      canDeleteExtra_Hour: false,
      canApproveExtra_Hour: false,


      //////////////Roles////////////////////
      roleFuncionario: false,
      roleGestorFuncionario: false,
      roleGestorAssiduidade: false,
      roleGestorlicencas: false,
      roleGestorRemuneracoes: false,
      roleGestorHst: false,
      roleGestorUtilizadores: false,
      roleAdmin: false,
      roleGestorSuperAdministrador: false,
      roleHoras: false,
      roleFerias: false,
      roleTurnos: false,



    }
  },


  computed: { //todo: descontinuei essa parte veja o watch e o metodo verifypermissions
    // canListEmp(){
    //   for(let permission in this.selectedUser.permissions){
    //     console.log("permissao", this.selectedUser.permissions[permission].name)
    //     if(this.selectedUser.permissions[permission].name == "list Employee"){
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    // canAddEmp(){
    //   for(let permission in this.selectedUser.permissions){
    //     console.log("permissao", this.selectedUser.permissions[permission].name)
    //     if(this.selectedUser.permissions[permission].name == "create Employee"){
    //       return true;
    //     }
    //   }
    //   return false;
    // }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getUsers();
    },


    removerPermissao() {
      //////////////////////////permissoes de funcionario//////////////////
      if (this.canListEmp != true) {
        this.permission_name.push("list Employee");
      }

      if (this.canAddEmp != true) {
        this.permission_name.push("create Employee");
      }
      if (this.canUpdateEmp != true) {
        this.permission_name.push("update Employee");
      }

      if (this.canDeleteEmp != true) {
        this.permission_name.push("delete Employee");
      }

      if (this.canApproveEmp != true) {
        this.permission_name.push("approve Employee");
      }
      //////////////////////////permissoes de EFECTIVIDADE//////////////////
      if (this.canListAttendance != true) {
        this.permission_name.push("list Attendance");
      }

      if (this.canAddAttendance != true) {
        this.permission_name.push("create Attendance");
      }
      if (this.canUpdateAttendance != true) {
        this.permission_name.push("update Attendance");
      }

      if (this.canDeleteAttendance != true) {
        this.permission_name.push("delete Attendance");
      }

      if (this.canApproveAttendance != true) {
        this.permission_name.push("approve Attendance");
      }
      //////////////////////////permissoes de FOLHA//////////////////
      if (this.canListPayroll != true) {
        this.permission_name.push("list Payroll");
      }

      if (this.canAddPayroll != true) {
        this.permission_name.push("create Payroll");
      }
      if (this.canUpdatePayroll != true) {
        this.permission_name.push("update Payroll");
      }

      if (this.canDeletePayroll != true) {
        this.permission_name.push("delete Payroll");
      }

      if (this.canApprovePayroll != true) {
        this.permission_name.push("approve Payroll");
      }




      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name: this.permission_name,

      };
      this.$validator.validateAll();
      http
        .post(`/permissions/remove_permissions/${this.selectedUser.id}`, data, config)
        .then((success) => {
          success;
          this.clean()

          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissões Removidas com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            })
          } else if (error.response.status == 200) {
            this.err = error.response.data
            console.log(this.err)
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: "falha ao salvar ",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }

        });


    },

    RemoverRole() {
      //////////////////////////Role//////////////////
      if (this.roleAdmin != true) {
        this.role_name.push("admin");
      }

      if (this.roleFuncionario != true) {
        this.role_name.push("Funcionario");
      }


      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        role_name: this.role_name,

      };
      this.$validator.validateAll();
      http
        .post(`/permissions/remove_roles/${this.selectedUser.id}`, data, config)
        .then((success) => {
          success;
          this.clean()

          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Funcões Removidas com sucesso!",
            color: "success",
            position: "top-right",
          });
          location.reload()
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            })
          } else if (error.response.status == 200) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: "falha ao salvar Utilizador ",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }

        });


    },


    getUsers() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },

        params: {
          type: 1
        }
      };

      http
        .get("/users/users", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.users = result.data.Users.reverse();
          // alert("2")
        })
        .catch((error) => {
          error;
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    clean() {
      this.permission_name = []
    },

    saveData() {

      if (this.canListEmp != true) {
        this.permission_name.push(this.canListEmp);
      }

      if (this.canAddEmp != true) {
        this.permission_name.push(this.canAddEmp);
      }
      if (this.canUpdateEmp != true) {
        this.permission_name.push(this.canUpdateEmp);
      }

      if (this.canDeleteEmp != true) {
        this.permission_name.push(this.canDeleteEmp);
      }

      if (this.canApproveEmp != true) {
        this.permission_name.push(this.canApproveEmp);
      }

      //////////////////////////////////////////////////////////////
      if (this.canListAttendance != true) {
        this.permission_name.push(this.canListAttendance);
      }

      if (this.canAddAttendance != true) {
        this.permission_name.push(this.canAddAttendance);
      }
      if (this.canUpdateAttendance != true) {
        this.permission_name.push(this.canUpdateAttendance);
      }

      if (this.canDeleteAttendance != true) {
        this.permission_name.push(this.canDeleteAttendance);
      }

      if (this.canApproveAttendance != true) {
        this.permission_name.push(this.canApproveAttendance);
      }
      ///////////////////////////////////////////////////////////////


      if (this.canListPayroll != true) {
        this.permission_name.push(this.canListPayroll);
      }

      if (this.canAddPayroll != true) {
        this.permission_name.push(this.canAddPayroll);
      }
      if (this.canUpdatePayroll != true) {
        this.permission_name.push(this.canUpdatePayroll);
      }

      if (this.canDeletePayroll != true) {
        this.permission_name.push(this.canDeletePayroll);
      }

      if (this.canApprovePayroll != true) {
        this.permission_name.push(this.canApprovePayroll);
      }


        ///////////////////////////////////////////////////////////////


        if (this.canListShift != true) {
        this.permission_name.push(this.canListShift);
      }

      if (this.canAddShift != true) {
        this.permission_name.push(this.canAddShift);
      }
      if (this.canUpdateShift != true) {
        this.permission_name.push(this.canUpdateShift);
      }

      if (this.canDeleteShift != true) {
        this.permission_name.push(this.canDeleteShift);
      }

      if (this.canApproveShift != true) {
        this.permission_name.push(this.canApproveShift);
      }

              ///////////////////////////////////////////////////////////////


              if (this.canListExtra_Hour != true) {
        this.permission_name.push(this.canListExtra_Hour);
      }

      if (this.canAddExtra_Hour != true) {
        this.permission_name.push(this.canAddExtra_Hour);
      }
      if (this.canUpdateExtra_Hour != true) {
        this.permission_name.push(this.canUpdateExtra_Hour);
      }

      if (this.canDeleteExtra_Hour != true) {
        this.permission_name.push(this.canDeleteExtra_Hour);
      }

      if (this.canApproveExtra_Hour != true) {
        this.permission_name.push(this.canApproveExtra_Hour);
      }

        ///////////////////////////////////////////////////////////////


        if (this.canListVacation != true) {
        this.permission_name.push(this.canListVacation );
      }

      if (this.canAddVacation  != true) {
        this.permission_name.push(this.canAddVacation );
      }
      if (this.canUpdateVacation  != true) {
        this.permission_name.push(this.canUpdateVacation );
      }

      if (this.canDeleteVacation  != true) {
        this.permission_name.push(this.canDeleteVacation );
      }

      if (this.canApproveVacation != true) {
        this.permission_name.push(this.canApproveVacation );
      }
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        permission_name: this.permission_name,

      };
      this.$validator.validateAll();
      http
        .post(`/permissions/grant_permissions/${this.selectedUser.id}`, data, config)
        .then((success) => {
          success;
          this.clean()
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Permissões atribuidas com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            })
          } else if (error.response.status == 200) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: "falha ao salvar Utilizador ",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }

        });


    },



    verifyRoles() {
      this.roleAdmin = this.roleGestorSuperAdministrador = this.roleGestorUtilizadores = this.roleGestorHst = this.roleGestorRemuneracoes = false//aumente a lista de variaveis aqui
    

      for (let role in this.selectedUser.roles) {
        if (this.selectedUser.roles[role].name == "Admin") {
          this.roleAdmin = true;

        }
        if (this.selectedUser.roles[role].name == "SuperAdmin") {
          this.roleGestorSuperAdministrador = true;
        }
        if (this.selectedUser.roles[role].name == "Gestor Funcionario") {
          this.roleGestorFuncionario = true;
        }
     
      }
    },

    verifyPermissions() {
      this.canListEmp = this.canAddEmp = this.canUpdateEmp = this.canDeleteEmp = this.canApproveEmp = this.canListAttendance = this.canAddAttendance = this.canUpdateAttendance = this.canDeleteAttendance = this.canApproveAttendance = this.canListPayroll = this.canAddPayroll = this.canUpdatePayroll = this.canDeletePayroll = this.canApprovePayroll =  false;//aumente a lista de variaveis aqui
     
      this.canLisVacation= false;
      this.canAddVacation= false,
      this.canUpdateVacation= false,
      this.canDeleteVacation= false,
      this.canApproveVacation= false,

      this.canListShift= false,
      this.canAddShift= false,
      this.canUpdateShift= false,
      this.canDeleteShift= false,
      this.canApproveShift= false,

      this.canListExtra_Hour= false,
      this.canAddExtra_Hour= false,
      this.canUpdateExtra_Hour= false,
      this. canDeleteExtra_Hour= false,
      this.canApproveExtra_Hour= false;

      for (let permission in this.selectedUser.permission) {

        if (this.selectedUser.permission[permission].name == "list Employee") {
          this.canListEmp = true;
        }
        if (this.selectedUser.permission[permission].name == "create Employee") {
          this.canAddEmp = true;
        }
        if (this.selectedUser.permission[permission].name == "update Employee") {
          this.canUpdateEmp = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Employee") {
          this.canDeleteEmp = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Employee") {
          this.canApproveEmp = true;
        }


        /////////////////////////EFECTIVIDADE
        if (this.selectedUser.permission[permission].name == "list Attendance") {
          this.canListAttendance = true;
        }
        if (this.selectedUser.permission[permission].name == "create Attendance") {
          this.canAddAttendance = true;
        }
        if (this.selectedUser.permission[permission].name == "update Attendance") {
          this.canUpdateAttendance = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Attendance") {
          this.canDeleteAttendance = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Attendance") {
          this.canApproveAttendance = true;
        }

        /////////////////////////PROCESSAR SALARIO
        if (this.selectedUser.permission[permission].name == "list Payroll") {
          this.canListPayroll = true;
        }
        if (this.selectedUser.permission[permission].name == "create Payroll") {
          this.canAddPayroll = true;
        }
        if (this.selectedUser.permission[permission].name == "update Payroll") {
          this.canUpdatePayroll = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Payroll") {
          this.canDeletePayroll = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Payroll") {
          this.canApprovePayroll = true;
        }
       
  /////////////////////////PROCESSAR turnos
  if (this.selectedUser.permission[permission].name == "list Shift") {
          this.canListShift = true;
        }
        if (this.selectedUser.permission[permission].name == "create Shift") {
          this.canAddShift = true;
        }
        if (this.selectedUser.permission[permission].name == "update Shift") {
          this.canUpdateShift = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Shift") {
          this.canDeleteShift = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Shift") {
          this.canApproveShift = true;
        }

        /////////////////////////PROCESSAR ferias
        if (this.selectedUser.permission[permission].name == "list Vacation") {
          this.canListVacation = true;
        }
        if (this.selectedUser.permission[permission].name == "create Vacation") {
          this.canAddVacation = true;
        }
        if (this.selectedUser.permission[permission].name == "update Vacation") {
          this.canUpdateVacation = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Vacation") {
          this.canDeleteVacation = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Vacation") {
          this.canApproveVacation = true;
        }

        /////////////////////////PROCESSAR ferias
        if (this.selectedUser.permission[permission].name == "list Extra_Hour") {
          this.canListExtra_Hour = true;
        }
        if (this.selectedUser.permission[permission].name == "create Extra_Hour") {
          this.canAddExtra_Hour = true;
        }
        if (this.selectedUser.permission[permission].name == "update Extra_Hour") {
          this.canUpdateExtra_Hour = true;
        }
        if (this.selectedUser.permission[permission].name == "delete Extra_Hour") {
          this.canDeleteExtra_Hour = true;
        }
        if (this.selectedUser.permission[permission].name == "approve Extra_Hour") {
          this.canApproveExtra_Hour = true;
        }


       
        
      }
    },


    saveRoles() {


      /////////////////////////////////////////// Permissoes de funcionarios //////////////////////////
      if (this.roleAdministrador != true) {
        this.role_name.push(this.roleAdministrador);
      }
      if (this.roleFuncionario != true) {
        this.role_name.push(this.roleFuncionario);
      }
      if (this.roleGestorFuncionario != true) {
        this.role_name.push(this.roleGestorFuncionario);
      }

      if (this.roleAssiduidade != true) {
        this.role_name.push(this.roleAssiduidade);
      }
    
      if (this.roleUtilizadores != true) {
        this.role_name.push(this.roleUtilizadores);
      }
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        role_name: this.role_name,

      };
      this.$validator.validateAll();
      http
        .post(`/permissions/grant_roles/${this.selectedUser.id}`, data, config)
        .then((success) => {
          success;
          this.clean()
          this.$validator.reset();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            })
          } else if (error.response.status == 200) {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: "falha ao salvar Utilizador ",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }

        });


    },

  },
  watch: {
    selectedUser() {
      this.verifyPermissions()
      this.verifyRoles()
    }
  }

}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}
</style>
